export const copilot = {
variant: {
recommendation: "Empfehlung",
action: "Aktion bereit",
insight: "Erkenntnis",
},
dismiss: {
accessibilityLabel: "Vorschlag verwerfen",
},
rationale: {
label: "Warum dies",
skillLabel: "Warum diese Fähigkeit",
riskLabel: "Warum diese Risikostufe",
notProvided: "Begründung wurde vom Modell nicht bereitgestellt.",
},
followUp: {
kicker: "KI erstellt Entwurf…",
loadingCaption: "Wählt die passende Fähigkeit, das Risiko und die Dringlichkeit anhand der Notizen dieses Eintrags aus.",
successKicker: "KI-Vorschlag bereit",
idleBodyWithAsset: "Die KI kann für diesen Eintrag auf {{assetName}} einen Folgeauftrag entwerfen — inklusive passender Fähigkeit, Risiko und Dringlichkeit, bevor Sie ihn annehmen.",
idleBodyNoAsset: "Die KI kann für diesen Eintrag einen Folgeauftrag entwerfen — inklusive passender Fähigkeit, Risiko und Dringlichkeit, bevor Sie ihn annehmen.",
suggestCta_one: "Mit KI vorschlagen · {{count}} Credit",
suggestCta_other: "Mit KI vorschlagen · {{count}} Credits",
createCta: "Folgeauftrag erstellen",
whyExpand: "Warum dies?",
whyCollapse: "Begründung ausblenden",
discard: "Verwerfen",
errorFallback: "Die KI konnte diesen Eintrag nicht analysieren.",
fallbackCta: "Entwurf manuell erstellen",
skillNotMatched: "Fähigkeit nicht zugeordnet",
skillNotInCatalogWarning: "Die KI hat eine Fähigkeit vorgeschlagen, die nicht in Ihrem Katalog enthalten ist. Wählen Sie auf dem nächsten Bildschirm manuell eine aus.",
},
riskLabel: {
low: "Geringes Risiko",
medium: "Mittleres Risiko",
high: "Hohes Risiko",
critical: "Kritisches Risiko",
},
urgencyLabel: {
standard: "Normal",
priority: "Priorität",
urgent: "Dringend",
},
confidence: {
high: "Hohe Sicherheit",
medium: "Mittlere Sicherheit",
low: "Vor dem Annehmen prüfen",
},
dock: {
openAssistant: "Assistent öffnen",
expandAssistant: "Assistent erweitern",
assistantTitle: "Assistent",
closeAssistant: "Assistent schließen",
loadingConversation: "Unterhaltung wird geladen...",
assistantEmptyTitle: "Fragen Sie den Assistenten",
assistantEmptyBody: "Nutzen Sie denselben Assistenten direkt in diesem Seitenbereich.",
actorYou: "Sie",
actorAssistant: "Assistent",
dictationInserting: "Transkript wird eingefügt…",
dictationFinishing: "Diktat wird beendet…",
dictationHeard: "Gehört: {{transcript}}",
dictationListening: "Zuhören…",
messageInputLabel: "Nachricht an den Assistenten",
messagePlaceholder: "Stellen Sie eine Frage oder sagen Sie dem Assistenten, was er tun soll",
stopDictation: "Diktat beenden",
dictateMessage: "Nachricht diktieren",
startNewThread: "Neuen Assistenten-Thread starten",
newThread: "Neuer Thread",
sendAssistantMessage: "Assistentennachricht senden",
sending: "Wird gesendet...",
send: "Senden",
noSuggestionsWithAsk: "Derzeit keine Vorschläge. Fragen Sie unten den Assistenten.",
noSuggestions: "Derzeit keine Vorschläge.",
openAssistantInput: "Assistenteneingabe öffnen",
askPlaceholder: "Fragen Sie den Assistenten…",
dictateAssistantMessage: "Nachricht an den Assistenten diktieren",
},
photoFixSuggestion: {
idleHeaderText: "Verwenden Sie das Foto, um eine Lösung zu entwerfen",
idleHint: "Die KI sieht sich das Foto und die Notizen des Prüfers an, um Titel, Umfang, Priorität und ungefähre Kosten vorzuschlagen.",
suggestA11y_one: "Lösungsvorschlag anhand des Fotos. Kostet {{count}} Credit.",
suggestA11y_other: "Lösungsvorschlag anhand des Fotos. Kostet {{count}} Credits.",
suggestButton_one: "Lösungsvorschlag anhand des Fotos ({{count}} Credit)",
suggestButton_other: "Lösungsvorschlag anhand des Fotos ({{count}} Credits)",
loadingStage1: "Foto wird ausgewertet…",
loadingStage2: "Wahrscheinlicher Fehler wird gesucht…",
loadingStage3: "Lösung wird entworfen…",
loadingStage4: "Fast geschafft…",
loadingHint: "Das Betrachten des Fotos dauert ein paar Sekunden – Sie können weiterarbeiten.",
retryA11y: "Lösungsvorschlag erneut versuchen",
tryAgain: "Erneut versuchen",
headerEyebrow: "KI-Lösungsvorschlag · {{pct}} % sicher",
priorityHigh: "Hoch",
priorityMedium: "Mittel",
priorityLow: "Niedrig",
priorityChip: "Priorität: {{level}}",
safetyCallouts: "Sicherheitshinweise",
useThisFixA11y: "Diese Lösung als Auftragsentwurf verwenden",
useThisFix: "Diese Lösung verwenden",
discardA11y: "Verwerfen Sie diesen Vorschlag",
discard: "Verwerfen",
},
};
